import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class JsonWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.json.ID;
		this.name = DatabaseEnum.json.NAME;
		this.code = DatabaseEnum.json.CODE;
		this.equivalentTag = DatabaseEnum.json.EQUIVALENT_TAG;
		//data object tabs
		this.showDataObjectPropertiesTab = true;
		this.isShowObjProperties = true;
		this.isFileType = true;
		this.complexAttrDTyp_Ids = [11,33];
    this.showDataDescription = false;

	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {

		if (!repConnWrapper.repConn.conn.fileloc.length) {
			repConnWrapper.inValid_Cds.push('NO_FILELOC');
		}

		if (repConnWrapper.repConn.conn.ftpFlag == 'Y') {
			if (!repConnWrapper.repConn.conn.ftpHost.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_HOST');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_HOST');

			}
			if (!repConnWrapper.repConn.conn.ftpPort.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_PORT');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_PORT');

			}
			if (!repConnWrapper.repConn.conn.ftpUsr.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_CONN_USR');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_CONN_USR');

			}
			if (!repConnWrapper.repConn.conn.ftpPasswd.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_PASSWORD');
				else
					repConnWrapper.inValid_Cds.push('NO_SFTP_PASSWORD');

			}
		}
		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}
		/*if(!repConnWrapper.repConn.conn.fileloc.length)
		{
			return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_FILELOC;
		}
		if( repConnWrapper.repConn.conn.flagent_Id == -1 )
		{
			return DIInValid_Cd.NATIVE_REP_CONNECTION_INVALID_AGENT;
		}
		if(repConnWrapper.repConn.conn.ftpFlag == DICodes.YES_FLAG)
		{
			if(!repConnWrapper.repConn.conn.ftpHost.length)
			{
				if( repConnWrapper.fileProtocol == DICodes.FTP_CODE )
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_FTP_HOST;
				else
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_SFTP_HOST;

			}
			if(!repConnWrapper.repConn.conn.ftpPort.length)
			{
				if( repConnWrapper.fileProtocol == DICodes.FTP_CODE )
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_FTP_PORT;
				else
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_SFTP_PORT;

			}
			if(!repConnWrapper.repConn.conn.ftpUsr.length)
			{
				if( repConnWrapper.fileProtocol == DICodes.FTP_CODE )
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_FTP_USER;
				else
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_SFTP_USER;

			}
			if(!repConnWrapper.repConn.conn.ftpPasswd.length)
			{
				if( repConnWrapper.fileProtocol == DICodes.FTP_CODE )
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_FTP_PWD;
				else
					return DIInValid_Cd.EXTERNAL_REP_CONNECTION_INVALID_SFTP_PWD;

			}
		}

		return DICodes.SUCCESS_CODE;*/
	}


	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getClevel(objectWrapper, true),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getTranspose(objectWrapper),
			//this.attributeTabulator.getTranspose(objectWrapper),
			this.attributeTabulator.getOccurs(objectWrapper),

			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	///to do
	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false,
		isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false,component:any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}

	showAttributeTranspose(attribute: Attribute, objectWrapper: ObjectWrapper): boolean {
		if (attribute.attrDTyp_Id != this.database.arrayId) return false;

		return true

	}

	hideNotNullFlag(attribute): boolean {

		return this.complexAttrDTyp_Ids.indexOf(parseInt(attribute.attrDTyp_Id)) != -1;
	}

	hideAttrKeyTyp_Id(attribute): boolean {

		return this.complexAttrDTyp_Ids.indexOf(parseInt(attribute.attrDTyp_Id)) != -1;
	}

	readFileCutOffLength(type: string): number {
        return -1;
    }
}
